import React from "react";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { AppBar, Box, IconButton, Toolbar, Typography, useTheme, useMediaQuery } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useSelector } from "react-redux";
import _ from "lodash";

const UISwipeableDrawer = (props) => {
  const apptheme = useSelector((state) => state.app?.theme);
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    props?.setOpen(open);
  };

  return (
    <SwipeableDrawer
      anchor={_.get(props, "anchor", "right")}
      open={_.get(props, "open", false)}
      onClose={toggleDrawer(false)}
      onOpen={toggleDrawer(true)}
      sx={{
        "& .MuiDrawer-paper": {
          borderRadius: props?.borderRadiusNone || "20px 0px 0px 20px",
          background: apptheme === "light" ? "#fff" : "#2D2C5A",
          zIndex: props.zIndex || 1300,
          width: {
            xs: props?.width || "95%",
            md: props?.width || "25%",
          },
        },
      }}
      {...props}
    >
      <AppBar
        sx={{
          position: "relative",
          background: apptheme === "dark" ? "#202529" : "#237FEA",
          display: props?.appBar === false && "none",
        }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="primary"
            onClick={toggleDrawer(false)}
            aria-label="close"
          >
            <Close />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            {_.get(props, "title", "")}
          </Typography>
        </Toolbar>
      </AppBar>
      <Box sx={{ padding: props?.padding || "15px" }}>
        {_.get(props, "jsx", <></>)}
      </Box>
    </SwipeableDrawer>
  );
};

export default UISwipeableDrawer;
